<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader" *ngIf="!isMyProfile"></app-content-header>
    <div class="row" *ngIf="currentUser">
      <div class="col-lg-3 col-12">
        <div class="card">
          <div class="card-body text-center">
            <div class="mb-1">
              <img
                *ngIf="currentUser.avatar !== null && currentUser.avatar.length > 0"
                class="rounded contain w-100"
                [src]="currentUser.avatar"
                [alt]="currentUser.firstname + ' ' + currentUser.lastname"
                width="300"
                height="300"
              />
              <div id="fake-avatar" class="rounded" *ngIf="currentUser.avatar === null || currentUser.avatar.length < 1">
                <span>{{ currentUser.firstname | initials }}{{ currentUser.lastname | initials }}</span>
              </div>
            </div>
            <div class="badge badge-light-primary profile-badge mr-1" [ngbTooltip]="'ROLE' | translate" has_capability="view_user_role"
                 *ngIf="currentUser.role && currentUser.type_code !== 'ex-employee'">
              {{ currentUser.role }}
            </div>
            <div class="badge badge-light-primary profile-badge mr-1" [ngbTooltip]="'ROLE' | translate" has_capability="view_user_role"
                 *ngIf="currentUser.role && currentUser.type_code === 'ex-employee'">
              {{ currentUser.type }}
            </div>
            <div class="badge badge-light-info profile-badge" *ngIf="currentUser.site" [ngbTooltip]="'JOB_SITE' | translate">{{ currentUser.site }}</div>
            <div class="d-flex justify-content-center align-items-center mt-2">
              <a href="mailto:{{ currentUser.email }}" [ngbTooltip]="currentUser.email">
                <i size="24" [data-feather]="'mail'"></i>
              </a>
              <a *ngFor="let social of currentUser.socials" [href]="social.url" target="_blank" [class]="'ml-1 text-' + social.name" [ngbTooltip]="social.name">
                <i size="24" [data-feather]="social.name"></i>
              </a>
            </div>
          </div>
        </div>

        <!-- Contatto di emergenza -->
        <div class="card my-padding" *ngIf="currentUser.emergency_contact_firstname && currentUser.emergency_contact_lastname && (isMyProfile || _authenticationService.hasCapability('view_others_emergency_contact'))">
          <div>
            <span class="text-danger">{{ "EMERGENCY_CONTACT" | translate }}</span>
            <p class="font-medium-1 mt-05 mb-025">{{ currentUser.emergency_contact_firstname }} {{ currentUser.emergency_contact_lastname }}</p>
            <a href="tel:{{ currentUser.emergency_contact_phone }}">{{ currentUser.emergency_contact_phone }}</a>
          </div>
        </div>
        <!-- modifica per i dipendenti -->
        <div class="card my-padding" *ngIf="(_authenticationService.hasCapability('view_others_documents') || isMyProfile) && !currentUser.isCollaborator">
          <div class="d-flex align-items-center cursor-pointer" [routerLink]="['/dashboard/user/edit/', this.identifier]">
            <div class="w-fit avatar avatar-lg bg-light-secondary">
              <div class="avatar-content">
                <i [data-feather]="'settings'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "DETAIL" | translate }}</h4>
            </div>
          </div>
        </div>
        <!-- modifica per i collaboratori -->
        <div class="card my-padding" *ngIf="(_authenticationService.hasCapability('edit_collaborator') || isMyProfile) && currentUser.isCollaborator">
          <div class="d-flex align-items-center cursor-pointer" [routerLink]="isMyProfile ? ['/dashboard/collaborator/edit-profile/', this.identifier] : ['/dashboard/collaborators/edit/', this.identifier]">
            <div class="w-fit avatar avatar-lg bg-light-secondary">
              <div class="avatar-content">
                <i [data-feather]="'settings'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "DETAIL" | translate }}</h4>
            </div>
          </div>
        </div>
        <!-- Documents -->
        <div class="card my-padding" *ngIf="_authenticationService.hasCapability('view_others_documents') || isMyProfile">
          <div
            class="d-flex align-items-center cursor-pointer"
            [routerLink]="isMyProfile ? '/dashboard/my-documents' : '/dashboard/documents-list'"
            [queryParams]="{ search: !isMyProfile ? currentUser.complete_name : null, ref: '/dashboard/user/profile/' + currentUser.hash }"
          >
            <div class="w-fit avatar avatar-lg bg-light-warning">
              <div class="avatar-content">
                <i [data-feather]="'folder'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "DOCUMENTS_AREA" | translate }}</h4>
            </div>
          </div>
        </div>
        <!-- Curriculum -->
        <div class="card my-padding" *ngIf="(_authenticationService.hasCapability('view_others_curriculum') || isMyProfile) && !currentUser.isCollaborator">
          <div class="d-flex align-items-center cursor-pointer" [routerLink]="'/dashboard/user/profile/' + currentUser.hash + '/curriculum'">
            <div class="w-fit avatar avatar-lg bg-light-info">
              <div class="avatar-content">
                <i [data-feather]="'server'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "TITLES.CURRICULUM" | translate }}</h4>
            </div>
          </div>
        </div>
        <!-- Contratto -->
        <div class="card my-padding" *ngIf="_authenticationService.hasCapability('view_others_contracts') && !isMyProfile && !currentUser.isCollaborator">
          <div class="d-flex align-items-center cursor-pointer" (click)="goToContract()">
            <div class="w-fit avatar avatar-lg bg-light-primary">
              <div class="avatar-content">
                <i [data-feather]="'box'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "CONTRACT" | translate }}</h4>
            </div>
          </div>
        </div>

        <!-- firma aziendale -->
        <div class="card" *ngIf="isMyProfile && !currentUser.isCollaborator">
          <div class="d-flex align-items-center my-padding border-bottom">
            <div class="w-fit avatar avatar-lg bg-light-danger">
              <div class="avatar-content">
                <i [data-feather]="'edit-3'"></i>
              </div>
            </div>
            <div class="ml-2">
              <h4 class="mb-0">{{ "CORPORATE_EMAIL_SIGNATURE" | translate }}</h4>
            </div>
          </div>
          <div class="card-body" id="signature">
            <p style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 11px; line-height: normal; font-family: 'Arial', sans-serif; -webkit-text-stroke-color: #000000">
              <strong>
                <span style="font-family: arial, helvetica, sans-serif; font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 14px; line-height: normal">{{
                    currentUser.complete_name
                  }}</span> </strong
              ><br />
              <span style="font-family: arial, helvetica, sans-serif"> <strong style="color: #ff6600">&lt;</strong> {{ currentUser.figure }} <strong style="color: #ff6600">/&gt;</strong> </span>
              <br />
              <!--il telefono è visibile solo se ha il permesso -->
              <span *ngIf="currentUser.private_phone"
              >Mob.: <a href="tel:{{ currentUser.private_phone }}" style="color: #ff6600; text-decoration: none">{{ currentUser.private_phone }}</a></span
              >
              <br />
              <span
              >Mail: <a href="mailto:{{ currentUser.email }}" style="color: #ff6600; text-decoration: none">{{ currentUser.email }}</a></span
              >
            </p>
            <p style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 11px; line-height: 15px; font-family: Arial, sans-serif; -webkit-text-stroke-color: #000000">
              <strong>
                <a href="https://www.nepta.it" style="font-family: arial, helvetica, sans-serif; color: #ff6600; text-decoration: none">www.nepta.it</a>
              </strong>
              <br />
              <a
                href="https://www.google.com/maps/place/Nepta+Srl/@41.8446707,12.6160399,17z/data=!3m1!4b1!4m5!3m4!1s0x13258805ba606595:0x2871526a85b13ae7!8m2!3d41.8446667!4d12.6182286"
                target="_blank"
                style="text-decoration: none; color: #000"
              >
                Viale Luigi Schiavonetti 294/A<br />
                00173 Roma(RM) </a
              ><br />
              <span style="display: block"
              >Tel.:
                <a href="tel:0687695282" style="color: #ff6600; text-decoration: none">06/87695282</a>
              </span>
            </p>
            <table>
              <tr>
                <td>
                  <img src="https://www.nepta.it/images/firma/logo.png" alt="Nepta - Inside your future" />
                </td>
                <td valign="top" style="padding-left: 12px">
                  <br />
                  <br />
                  <a href="https://www.instagram.com/nepta_soluzioni/" target="_blank"><img src="https://www.nepta.it/images/firma/instagram.png" alt="Instagram" /></a>
                  &nbsp; <a href="https://www.linkedin.com/company/nepta/" target="_blank"><img src="https://www.nepta.it/images/firma/linkedin.png" alt="LinkedIn" /></a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="col-lg-9 col-12 printRef">
        <!-- Anagrafica-->
        <div class="card">
          <div class="card-header d-flex align-items-center px-2 border-bottom">
            <h4 class="mb-0">{{ "MASTERDATA" | translate }}</h4>
          </div>
          <!-- Address And Contact Starts -->
          <div class="card-body invoice-padding pt-1 pb-3 px-1">
            <div class="invoice-spacing">
              <div
                class="col-12 mb-4"
                *ngIf="currentUser?.addresses?.residenza || currentUser?.department || currentUser?.figure || currentUser?.birthday || currentUser?.birth_place || currentUser.private_email || currentUser.private_phone"
              >
                <div class="row">
                  <div
                    class="col-lg-6 col-12 mt-1"
                    *ngIf="
                      (isMyProfile || _authenticationService.hasCapability('view_user_address')) &&
                      currentUser?.addresses?.residenza &&
                      currentUser?.addresses?.residenza.city &&
                      currentUser?.addresses?.residenza.province
                    "
                  >
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "RESIDENCE_CITY" | translate }}:</label>
                    <span>{{ currentUser?.addresses?.residenza.city + " (" + currentUser?.addresses?.residenza?.province + ")" }}</span>
                  </div>
                  <div
                    class="col-lg-6 col-12 mt-1"
                    *ngIf="
                      currentUser?.addresses?.residenza &&
                      currentUser?.addresses?.residenza.street &&
                      currentUser?.addresses?.residenza.zipcode &&
                      currentUser?.addresses?.residenza.city &&
                      currentUser?.addresses?.residenza.province
                    "
                  >
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ADDRESS_STREET" | translate }}:</label>
                    <span
                    >{{ currentUser.addresses.residenza.street }}
                      {{ currentUser.addresses.residenza.zipcode + ", " + currentUser.addresses.residenza.city + " (" + currentUser.addresses.residenza.province + ")" }}
                    </span>
                  </div>
                  <!-- indirizzo estero -->
                  <div
                    class="col-lg-6 col-12 mt-1"
                    *ngIf="
                      currentUser?.addresses?.residenza &&
                      currentUser?.addresses?.residenza.street &&
                      currentUser?.addresses?.residenza.country &&
                      !currentUser?.addresses?.residenza.city &&
                      !currentUser?.addresses?.residenza.zipcode &&
                      !currentUser?.addresses?.residenza.province
                    "
                  >
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ADDRESS_STREET" | translate }}:</label>
                    <span>{{ currentUser.addresses.residenza.street }}, {{ currentUser.addresses.residenza.country }} </span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.figure">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "FIGURE" | translate }}:</label>
                    <span>{{ currentUser.figure }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.birthday">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "BIRTHDAY" | translate }}:</label>
                    <span>{{ _utilService.formatDate(currentUser.birthday) }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.birth_place">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "BIRTH_PLACE" | translate }}:</label>
                    <span>{{ currentUser.birth_place }}</span>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.private_email">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "PRIVATE_EMAIL" | translate }}:</label>
                    <a href="mailto:{{ currentUser.private_email }}" [ngbTooltip]="'SEND_EMAIL' | translate">{{ currentUser.private_email }} </a>
                  </div>
                  <div class="col-lg-6 col-12 mt-1" *ngIf="currentUser?.private_phone">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "PRIVATE_PHONE" | translate }}:</label>
                    <a [href]="'tel:' + currentUser.private_phone" [ngbTooltip]="'CALL' | translate">{{ currentUser.private_phone }}</a>
                  </div>
                </div>
              </div>
              <div
                class="col-12"
                *ngIf="
                  currentUser.hr_name ||
                  currentUser.working_city ||
                  currentUser.nationality ||
                  currentUser.type ||
                  currentUser.fiscal_code ||
                  currentUser.has_welcomebox !== null ||
                  currentUser.send_onboarding !== null ||
                  (currentUser.contract && currentUser.contract.start_date) ||
                  currentUser.education ||
                  currentUser.civil_status ||
                  currentUser.has_child !== null ||
                  currentUser.IBAN ||
                  currentUser.vat_number ||
                  currentUser.need_assets !== null
                "
              >
                <h4>{{ "INFO" | translate }}</h4>
                <div class="row">
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.hr_name && currentUser.hr_name !== !!currentUser.hr_name && currentUser.hr_name !== ' '">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "HR_REFERENCE" | translate }}:</label>
                    <span>{{ currentUser.hr_name }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.working_city">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "CITY" | translate }}:</label>
                    <span>{{ currentUser.working_city }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.nationality">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "NATIONALITY" | translate }}:</label>
                    <span>{{ currentUser.nationality }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.fiscal_code">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "FISCAL_CODE" | translate }}:</label>
                    <span>{{ currentUser.fiscal_code }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.has_welcomebox && currentUser.has_welcomebox !== null">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "HAS_WELCOMEBOX" | translate }}:</label>
                    <div *ngIf="currentUser.has_welcomebox === 0" class="badge badge-pill badge-light-danger mr-1">{{ "NOT_RECEIVED" | translate }}</div>
                    <div *ngIf="currentUser.has_welcomebox === 1" class="badge badge-pill badge-light-success mr-1">{{ "RECEIVED" | translate }}</div>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.contract && currentUser.contract.start_date">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ASSUMPTION_DATE" | translate }}:</label>
                    <span>{{ _utilService.formatDate(currentUser.contract.start_date) }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.educations && currentUser.educations.length > 0">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "EDUCATION_TITLE" | translate }}:</label>
                    <span>{{ currentUser.educations[0].title_name }} {{ currentUser.educations[0].graduate_name || currentUser.educations[0].subject }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.civil_status">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "CIVIL_STATUS" | translate }}:</label>
                    <span>{{ currentUser.civil_status }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.hasOwnProperty('has_child') && currentUser.has_child !== null">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "HAS_CHILD" | translate }}:</label>
                    <span>{{ (currentUser.has_child ? "YES" : "NO") | translate }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.child_number > 0">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "CHILD_NUMBER" | translate }}:</label>
                    <span>{{ currentUser.child_number }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.IBAN">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "IBAN" | translate }}:</label>
                    <span>{{ currentUser.IBAN }}</span>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.vat_number && currentUser.type_code === 'collaborator'">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "VAT_NUMBER" | translate }}:</label>
                    <span>{{ currentUser.vat_number }}</span>
                  </div>
                  <div class="mt-1 col-12" *ngIf="currentUser.assets && currentUser.assets.length > 0">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ASSETS" | translate }}:</label>
                    <div class="d-inline-block mr-075" *ngFor="let asset of currentUser.assets; let i = index">
                      <a [routerLink]="'/dashboard/assets/detail/' + asset.id" *ngIf="_authenticationService.hasCapability('view_asset')">{{ asset.name }}</a>
                      <span *ngIf="!_authenticationService.hasCapability('view_asset')">{{ asset.name }}</span>
                      <ng-container *ngIf="i < currentUser.assets.length - 1">,</ng-container>
                    </div>
                  </div>
                  <div class="mt-1 col-lg-6 col-12" *ngIf="currentUser.cost_total_daily">
                    <label class="font-medium-1 font-weight-bold mr-05">{{ "ESTIMATED_DAILY_COST" | translate }}:</label>
                    <span>{{ currentUser.cost_total_daily | currency: "EUR" }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Esperienze, competenze e certificazioni -->
        <div class="card" id="eccTale" *ngIf="(currentUser.experiences && currentUser.experiences.length > 0) || (currentUser.skills && currentUser.skills.length > 0) ||
            (currentUser.certifications && currentUser.certifications.length > 0) || (currentUser.educations && currentUser.educations.length > 1) || (currentUser.languages && currentUser.languages.length > 0)">
          <div class="card-body pt-1 pb-0">
            <div *ngIf="_utilService.isMobile" class="mb-1">
              <ng-select [searchable]="false" [(ngModel)]="eccTableIndex" [clearable]="false">
                <ng-option value="experience" *ngIf="currentUser.experiences && currentUser.experiences.length > 0">{{ "EXPERIENCES" | translate }}</ng-option>
                <ng-option value="skill" *ngIf="currentUser.skills && currentUser.skills.length > 0">{{ "SKILLS" | translate }}</ng-option>
                <ng-option value="educations" *ngIf="currentUser.educations && currentUser.educations.length > 0">{{ "EDUCATION_ONBOARDING" | translate }}</ng-option>
                <ng-option value="certification" *ngIf="currentUser.certifications && currentUser.certifications.length > 0">{{ "CERTIFICATIONS" | translate }}</ng-option>
                <ng-option value="language" *ngIf="currentUser.languages && currentUser.languages.length > 0">{{ "LANGUAGES" | translate }}</ng-option>
              </ng-select>
            </div>
            <nav class="d-flex" *ngIf="!_utilService.isMobile" [ngClass.xl]="'align-items-center justify-content-between'" [ngClass.md]="'align-items-center justify-content-between flex-wrap'">
              <li *ngIf="currentUser.experiences && currentUser.experiences.length > 0">
                <a (click)="eccTableIndex = 'experience'" [class]="eccTableIndex === 'experience' ? 'current' : ''">{{ "EXPERIENCES" | translate }}</a>
              </li>
              <li *ngIf="currentUser.skills && currentUser.skills.length > 0">
                <a (click)="eccTableIndex = 'skill'" [class]="eccTableIndex === 'skill' ? 'current' : ''">{{ "SKILLS" | translate }}</a>
              </li>
              <li *ngIf="currentUser.educations && currentUser.educations.length > 1">
                <a (click)="eccTableIndex = 'educations'" [class]="eccTableIndex === 'educations' ? 'current' : ''">{{ "EDUCATION_ONBOARDING" | translate }}</a>
              </li>
              <li *ngIf="currentUser.certifications && currentUser.certifications.length > 0">
                <a (click)="eccTableIndex = 'certification'" [class]="eccTableIndex === 'certification' ? 'current' : ''">{{ "CERTIFICATIONS" | translate }}</a>
              </li>
              <li *ngIf="currentUser.languages && currentUser.languages.length > 0">
                <a (click)="eccTableIndex = 'language'" [class]="eccTableIndex === 'language' ? 'current' : ''">{{ "LANGUAGES" | translate }}</a>
              </li>
            </nav>
            <div *ngIf="eccTableIndex === 'experience'">
              <ngx-datatable
                *ngIf="currentUser.experiences && currentUser.experiences.length > 0"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                id="experiencesTable"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="!_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 80"
                [limit]="10"
                [footerHeight]="_utilService.isDesktop ? 50 : 5"
                [rows]="currentUser.experiences"
                (activate)="$event.type !== 'click' ? null : openModalExperiences(modalExperience, $event.row)"
              >
                <ngx-datatable-column [name]="'AGENCY_NAME' | translate" prop="agency" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.agency }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="('FROM' | translate) + '/' + ('TO' | translate)" prop="from" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ _utilService.formatDate(row.from) }} - {{ _utilService.formatDate(row.to) }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'FIGURE' | translate" prop="domain" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.figure }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.experiences === null || currentUser.experiences.length < 1" class="no-items font-medium-1">
                {{ "NO_EXPERIENCES_FOR_THIS_USER" | translate }}
              </p>
            </div>
            <div *ngIf="eccTableIndex === 'skill'">
              <ngx-datatable
                *ngIf="currentUser.skills && currentUser.skills.length > 0"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="!_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 80"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.skills"
              >
                <ngx-datatable-column [name]="'SINGLE_COMPETENCE' | translate" prop="name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.name }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LEVEL' | translate" prop="level" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.level }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.skills === null || currentUser.skills.length < 1" class="no-items font-medium-1">
                {{ "NO_SKILL_FOR_THIS_USER" | translate }}
              </p>
            </div>
            <div *ngIf="eccTableIndex === 'educations'">
              <ngx-datatable
                *ngIf="currentUser.educations && currentUser.educations.length > 1"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="!_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 80"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.educations"
              >
                <ngx-datatable-column [name]="'TITLE' | translate" prop="title_name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.title_name }} {{ row.graduate_name || row.subject }} </span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'EDUCATION_VOTE' | translate" prop="vote" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.vote || "-" }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>

            <div *ngIf="eccTableIndex === 'certification'">
              <ngx-datatable
                *ngIf="currentUser.certifications && currentUser.certifications.length > 0"
                class="bootstrap core-bootstrap"
                [ngClass.md]="'heightDatatable'"
                columnMode="force"
                [headerHeight]="50"
                [scrollbarH]="true"
                [scrollbarV]="!_utilService.isDesktop"
                [rowHeight]="_utilService.isDesktop ? 70 : 90"
                [footerHeight]="_utilService.isDesktop ? 50 : 0"
                [limit]="10"
                [rows]="currentUser.certifications"
              >
                <ngx-datatable-column [name]="'SINGLE_COMPETENCE' | translate" prop="name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.name }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LINK' | translate" prop="proof" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.proof }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.skills === null || currentUser.certifications.length < 1" class="no-items font-medium-1">
                {{ "NO_CERTIFICATION_FOR_THIS_USER" | translate }}
              </p>
            </div>
            <div *ngIf="eccTableIndex === 'language'">
              <ngx-datatable *ngIf="currentUser.languages && currentUser.languages.length > 0" class="bootstrap core-bootstrap" [ngClass.md]="'heightDatatable'"
                             columnMode="force" [headerHeight]="50" [scrollbarH]="true" [scrollbarV]="!_utilService.isDesktop" [rowHeight]="_utilService.isDesktop ? 70 : 80"
                             [footerHeight]="_utilService.isDesktop ? 50 : 0" [limit]="10" [rows]="currentUser.languages">
                <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.name }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LEVEL_SPEAK' | translate" prop="speak" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.speak }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'LEVEL_WRITE' | translate" prop="write" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span>{{ row.write }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <p *ngIf="currentUser.languages === null || currentUser.languages.length < 1" class="no-items font-medium-1">
                {{ "NO_LANGUAGES_FOR_THIS_USER" | translate }}
              </p>
            </div>
          </div>
        </div>

        <!-- Commesse-->
        <div class="card" *ngIf="_authenticationService.hasCapability('show_user_commissions_stats') && !isMyProfile">
          <div class="card-header d-flex align-items-center px-2">
            <h4 class="mb-0">{{ "MENU.COMMISSION" | translate }}</h4>
          </div>
          <!-- Address And Contact Starts -->
          <div class="card-body p-0" *ngIf="commissionsIsLoading">
            <div class="row mb-2">
              <div class="col-md-6 col-12 offset-md-3 pb-2">
                <img class="d-block col-md-4 offset-md-4 col-12" src="assets/images/misc/bit-loading-animation.gif" alt="Bit" />
                <div class="text-center">{{ "LOADING_USER_COMMISSIONS" | translate }}...</div>
              </div>
            </div>
          </div>
          <div class="card-body p-0" *ngIf="!commissionsIsLoading">
            <div class="pb-1 col-12 d-flex align-items-center">
              <label for="month" class="mr-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
                <select [(ngModel)]="commissionsFilterMonth" (ngModelChange)="loadCommissions()" id="month" class="form-control pr-3 text-capitalize">
                  <option *ngFor="let month of availableMonths" [value]="month" [label]="formatMonth(month)">{{ month }}</option>
                </select>
              </label>
              <label for="year" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
                <select [(ngModel)]="commissionsFilterYear" (ngModelChange)="loadCommissions()" id="year" class="form-control pr-3 text-capitalize">
                  <option *ngFor="let year of availableYears" [value]="year" [label]="year">{{ year }}</option>
                </select>
              </label>
            </div>
            <ngx-datatable class="bootstrap core-bootstrap w-100" columnMode="force" [headerHeight]="30" [scrollbarH]="true"
                           [rowHeight]="_utilService.isDesktop ? 60 : 200" [limit]="_utilService.isDesktop ? 10 : 999" [footerHeight]="0" [rows]="userCommissions"
                           [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }">
              <ngx-datatable-column [name]="'COMMISSION' | translate" prop="complete_name" *ngIf="_utilService.isDesktop" width="200">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <a *ngIf="row.commission_id" class="text-break-line-2" target="_blank"
                     [ngbTooltip]="row.complete_name" [routerLink]="'/dashboard/commission/edit/' + row.commission_id"
                     [queryParams]="{ tab_name: 'economic' }">{{ row.complete_name ? row.complete_name : "-" }}</a>
                  <a *ngIf="row.structure_id" class="text-break-line-2" target="_blank"
                     [ngbTooltip]="row.complete_name" [routerLink]="'/dashboard/costs/structure-cost-list'"
                     [queryParams]="{ structure_cost: row.structure_id }">{{ row.complete_name ? row.complete_name : "-" }}</a>
                  <strong *ngIf="!row.commission_id && !row.structure_id">{{ row.complete_name }}</strong>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [name]="'END_DATE' | translate" prop="to" *ngIf="_utilService.isDesktop">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div>{{ row.to | date: "dd/MM/yyyy" }}</div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [name]="'COST' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="d-flex align-items-center">{{ row.analytics.real_cost | currency: "EUR" }}</div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [name]="'REVENUE' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="d-flex align-items-center">{{ row.analytics.real_profit | currency: "EUR" }}</div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [name]="'EURO_MARGIN' | translate" prop="margin_currency" *ngIf="_utilService.isDesktop">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="d-flex align-items-center">{{ (row.analytics.real_profit < 1 ? 0 : (row.analytics.real_profit - row.analytics.real_cost)) | currency: "EUR" }}</div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [name]="'PERCENTAGE_MARGIN' | translate" prop="margin_percentage" *ngIf="_utilService.isDesktop">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="d-flex align-items-center">{{ row.analytics.real_profit < 1 ? 0 : _utilService.calculatePercentageBetweenTwoNumbers(row.analytics.real_profit, row.analytics.real_cost) }} %</div>
                </ng-template>
              </ngx-datatable-column>
              <!--mobile - tablet-->
              <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="col-12 list-item-mobile pl-0">
                    <div>
                      <a [routerLink]="'/dashboard/commission/edit/' + row.commission_id" [queryParams]="{ tab_name: 'economic' }" target="_blank">{{ row.complete_name }}</a>
                    </div>
                    <div>
                      <span>{{ "TO" | translate }}: </span>
                      <span>{{ row.to | date: "dd/MM/yyyy" }}</span>
                    </div>
                    <div>
                      <span>{{ "COST" | translate }}: </span>
                      <span>{{ row.analytics.real_cost | currency: "EUR" }}</span>
                    </div>
                    <div>
                      <span>{{ "REVENUE" | translate }}: </span>
                      <span>{{ row.analytics.real_profit | currency: "EUR" }}</span>
                    </div>
                    <div>
                      <span>{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                      <span>{{ row.analytics.margin_percentage }} %</span>
                    </div>
                    <div>
                      <span>{{ "EURO_MARGIN" | translate }}: </span>
                      <span>{{ row.analytics.margin_currency ? (row.analytics.margin_currency | currency: "EUR") : "-" }}</span>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
          <div class="card-footer px-1 py-1" *ngIf="_utilService.isDesktop">
            <div>
              <strong>{{ "TOTAL_COSTS" | translate }}</strong>: <span class="font-weight-bold">{{ totalCost | currency: "EUR" }}</span>
            </div>
            <div>
              <strong>{{ "TOTAL_REVENUE" | translate }}</strong>: <span class="font-weight-bold">{{ totalRevenue | currency: "EUR" }}</span>
            </div>
            <div>
              <strong>{{ "TOTAL_PERCENTAGE_MARGIN" | translate }}</strong>: <span class="font-weight-bold">{{ totalMarginPercentage }}%</span>
            </div>
            <div>
              <strong>{{ "TOTAL_EURO_MARGIN" | translate }}</strong>: <span class="font-weight-bold">{{ totalMarginCurrency | currency: "EUR" }}</span>
            </div>
          </div>
        </div>
        <div class="card" *ngIf="_authenticationService.hasCapability('show_user_economic_graph') && !isMyProfile">
          <div class="card-header d-flex align-items-center px-2">
            <h4 class="mb-0">{{ "ECONOMIC_GRAPH" | translate }}</h4>
          </div>
          <div class="card-body p-0">
            <div class="row mb-2">
              <div class="col-12 pb-2">
                <app-user-economic-graph [userHash]="currentUser.hash" [availableYears]="availableYears"></app-user-economic-graph>
              </div>
            </div>
          </div>
        </div>
        <!-- Ferie, permessi e malattie -->
        <div class="card" *ngIf="isMyProfile || _authenticationService.hasCapability('view_ferie_permessi')">
          <div class="card-body p-0">
            <div class="d-flex align-items-center justify-content-start px-2 py-1 text-uppercase bg-table-header-dark">
              <h4 class="text-primary flex-basis-50 font-small-3 font-weight-bolder m-0">{{ "DEMANDS.HOLIDAYS" | translate }} , {{ "DEMANDS.PERMISSIONS" | translate }} , {{ "DEMANDS.SICKNESS" | translate }}</h4>
              <div class="font-weight-bold text-secondary font-small-3" [ngClass.sm]="'flex-basis-20'" [ngClass.xl]="'flex-basis-30'" [ngClass.md]="'flex-basis-30'">{{ "DAYS" | translate }}</div>
              <div class="text-right" [ngClass.sm]="'flex-basis-30'" [ngClass.xl]="'flex-basis-20'" [ngClass.md]="'flex-basis-20'">
                <select class="form-control text-capitalize" (change)="allAbsences($event)">
                  <option selected disabled="disabled" value="2023">{{ "YEAR" | translate }}</option>
                  <option *ngFor="let year of last5years" [value]="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start border-top px-2 py-1 text-secondary cursor-pointer"
                 *ngFor="let item of all_absences" (click)="openModalAbsences(modalAbsences, item.name, selectedYearAbsence)">
              <div class="flex-basis-50">{{ item.name === "ferie" ? ("DEMANDS.HOLIDAYS" | translate) : item.name === "permesso" ? ("DEMANDS.PERMISSIONS" | translate) : ("DEMANDS.SICKNESS" | translate) }}</div>
              <div class="flex-basis-50">{{ item.amount }}{{ item.name === "permesso" ? "h" : "" }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" has_capability="view_users_notes">
        <div class="card">
          <div class="card-title px-2 pt-2 m-0">
            <h4 class="m-0">{{ "NOTES" | translate }}</h4>
          </div>
          <section class="card-body">
            <div id="list-notes" *ngIf="currentUser && currentUser.notes && currentUser.notes.length > 0">
              <div class="note" *ngFor="let note of currentUser.notes; let index = index">
                <header class="note-header">
                  {{ _utilService.formatDate(note.insert_date) }} -
                  <strong>{{ note.creator_firstname }} {{ note.creator_lastname }}</strong>
                </header>
                <div class="note-content" [innerHTML]="note.note"></div>
              </div>
            </div>
            <h4 *ngIf="!currentUser.notes || !currentUser.notes || currentUser.notes.length < 1" class="font-medium-1 font-weight-normal">{{ "NO_NOTES" | translate }}</h4>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>

<block-ui></block-ui>

<!-- Modal Absences -->
<ng-template #modalAbsences let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "RESUME" | translate }} {{ demand_modal_data[0].category }}</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0" tabindex="0">
    <table class="table">
      <thead>
      <th class="bt-0 text-primary">{{ "CATEGORY" | translate }}</th>
      <th class="bt-0">{{ "FROM" | translate }} / {{ "TO" | translate }}</th>
      </thead>
      <tbody>
      <tr *ngFor="let demand of demand_modal_data">
        <td class="text-capitalize">{{ demand.type.category }}</td>
        <td>{{ demand.date_from }} - {{ demand.date_to }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<!-- / Modal Absences -->

<!-- Modal Experience -->
<ng-template #modalExperience let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "EXPERIENCE_DETAIL" | translate }}</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <div class="row">
      <div class="form-group col-lg-6 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "AGENCY_NAME" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.agency || "-" }}</div>
      </div>
      <div class="form-group col-lg-6 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "CUSTOMER" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.customer || "-" }}</div>
      </div>
      <div class="form-group col-lg-3 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "FROM" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.from ? _utilService.formatDate(currentExperience.from) : "-" }}</div>
      </div>
      <div class="form-group col-lg-3 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "TO" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.to ? _utilService.formatDate(currentExperience.to) : "-" }}</div>
      </div>
      <div class="form-group col-lg-6 col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "FIGURE" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.figure || "-" }}</div>
      </div>
      <div class="form-group col-12 font-medium-1 d-flex align-items-center">
        <div class="font-weight-bold">{{ "DOMAIN" | translate }}:&nbsp;&nbsp;</div>
        <div>{{ currentExperience.domain_name || "-" }}</div>
      </div>
      <div class="form-group col-12 font-medium-1 d-flex">
        <div class="font-weight-bold">{{ "TECNOLOGIES" | translate }}:&nbsp;&nbsp;</div>
        <div>
          <span *ngFor="let skill of currentExperience.skill_names" class="badge badge-pill badge-light-secondary mb-05 mr-075">{{ skill }}</span>
        </div>
      </div>
      <div class="form-group col-12 font-medium-1">
        <div class="font-weight-bold mb-05">{{ "DESCRIPTION" | translate }}</div>
        <em>{{ currentExperience.description || "-" }}</em>
      </div>
    </div>
  </div>
</ng-template>
<!-- / Modal Absences -->
